<p-confirmDialog />
<p-toast />
<div id="addnewdonor">
  <p-stepper (activeStepChange)="stepChange($event)" #addDonorStepper orientation="vertical"  >
    <p-stepperPanel header="General Information">
      <ng-template pTemplate="content" let-nextCallback="nextCallback" let-index="index">
        <form [formGroup]="form" data-cy="general-info-form">
          <p-card>
            <div class="formgrid grid">
              <div class="field col-12 sm:col-6 xl:col-4">
                <label for="donorTypeId" class="field-label required">Donor Type</label>
                <p-dropdown id="donorTypeId" formControlName="selectedDonorType" [options]="donorTypes" optionLabel="text"
                            placeholder="Please Select" (onChange)="donorTypeChanged($event)" dataKey="value" data-cy="dropdown-donor-type"/>
                <div *ngIf="form.controls['donorTypeId'].invalid && form.controls['donorTypeId'].touched" class="block p-error">
                  <small id="donorTypeid-error" class="error"> Please select donor type. </small>
                </div>
              </div>
            </div>
          </p-card>

          <p-card *ngIf="form.controls['donorTypeId']?.value">
            <div class="formgrid grid">

              <div class="field col-12 sm:col-6 md:col-4 xl:col-1 xxl:col-1">
                <label for="prefix" class="field-label">Prefix</label>
                <input id="prefix" type="text" pInputText formControlName="prefix" data-cy="input-prefix"/>
                <div *ngIf="form.controls['prefix'].errors && form.controls['prefix'].touched" class="block p-error">
                  <small class="error" *ngIf="form.controls['prefix'].errors?.['invalidName']">
                    Please enter a valid prefix.
                  </small>
                  <small class="error" *ngIf="form.controls['prefix'].errors?.['noNumbers']">
                    Numbers are not allowed.
                  </small>
                </div>
              </div>

              <div class="field col-12 sm:col-6 md:col-4 xl:col-3 xxl:col-3">
                <label for="firstName" [class]="labelClassR">First Name</label>
                <input id="firstName" type="text" pInputText formControlName="firstName" data-cy="input-first-name"/>
                <div *ngIf="form.controls['firstName'].errors && form.controls['firstName'].touched"
                     class="block p-error">
                  <small class="error" *ngIf="form.controls['firstName'].errors?.['required']">
                    Please enter donor first name.
                  </small>
                  <small class="error" *ngIf="form.controls['firstName'].errors?.['invalidName']">
                    The first name contains invalid characters.
                  </small>
                  <small class="error" *ngIf="form.controls['firstName'].errors?.['noNumbers']">
                    Numbers are not allowed in the first name.
                  </small>
                </div>
              </div>

              <div class="field col-12 sm:col-6 md:col-4 xl:col-3">
                <label for="middleName" class="field-label">Middle Name</label>
                <input id="middleName" type="text" pInputText formControlName="middleName" data-cy="input-middle-name"/>
                <div *ngIf="form.controls['middleName'].invalid && form.controls['middleName'].touched"
                     class="block p-error">
                  <small class="error" *ngIf="form.controls['middleName'].errors?.['invalidName']">
                    The middle name contains invalid characters.
                  </small>
                  <small class="error" *ngIf="form.controls['middleName'].errors?.['noNumbers']">
                    Numbers are not allowed in the middle name.
                  </small>
                </div>
              </div>

              <div class="field col-12 sm:col-6 md:col-4 xl:col-3 xxl:col-3">
                <label for="lastName" [class]="labelClassR">Last Name</label>
                <input id="lastName" type="text" pInputText formControlName="lastName" data-cy="input-last-name"/>
                <div *ngIf="form.controls['lastName'].invalid && form.controls['lastName'].touched"
                     class="block p-error">
                  <small class="error" *ngIf="form.controls['lastName'].errors?.['required']">
                    Please enter donor last name.
                  </small>
                  <small class="error" *ngIf="form.controls['lastName'].errors?.['invalidName']">
                    The last name contains invalid characters.
                  </small>
                  <small class="error" *ngIf="form.controls['lastName'].errors?.['noNumbers']">
                    Numbers are not allowed in the last name.
                  </small>
                </div>
              </div>

              <div class="field col-12 sm:col-6 md:col-4 xl:col-2 xxl:col-1">
                <label for="suffix" class="field-label">Suffix</label>
                <input id="suffix" type="text" pInputText formControlName="suffix" data-cy="input-suffix"/>
              </div>

            </div>
          </p-card>

          <p-card *ngIf="form.controls['donorTypeId']?.value && form.controls['donorTypeId'].value === '7' ">
            <div class="formgrid grid">

              <div class="field col-12 sm:col-6 xl:col-4" data-cy="donor-employment">
                <label for="currentlyEmployed" class="field-label">Currently Employed?</label>
              </div>
              <div class="field col-12 sm:col-6 xl:col-4">
                <div class="flex flex-wrap gap-3">
                  <div class="flex align-items-center">
                    <p-radioButton name="currentlyEmployed" value="yes"
                                   formControlName="currentlyEmployed" data-cy="radio-employed-yes"></p-radioButton>
                    <label for="currentlyEmployed" class="ml-2">Yes</label>
                  </div>
                  <div class="flex align-items-center">
                    <p-radioButton name="currentlyEmployed" value="no"
                                   formControlName="currentlyEmployed" data-cy="radio-employed-no"></p-radioButton>
                    <label for="currentlyEmployed" class="ml-2">No</label>
                  </div>
                </div>
              </div>
            </div>

            <div class="formgrid grid">

              <div class="field col-12 sm:col-6 md:col-4 xl:col-3" *ngIf="isEmployed === 'no'">
                <label for="employmentStatus" class="field-label">Employment Status</label>
                <p-dropdown id="employmentStatus" formControlName="employmentStatus" [options]="employmentStatuses"
                            optionLabel="name" optionValue="value" placeholder="Please Select" data-cy="dropdown-employment-status"/>
              </div>

              <div class="field col-12 sm:col-6 md:col-4 xl:col-3" *ngIf="isEmployed === 'yes'">
                <label for="employer" class="field-label">Employer</label>
                <input id="employer" type="text" pInputText formControlName="employer" data-cy="input-employer"/>
              </div>

              <div class="field col-12 sm:col-6 md:col-4 xl:col-3" *ngIf="isEmployed === 'yes'">
                <label for="occupation" class="field-label">Occupation</label>
                <input id="occupation" type="text" pInputText formControlName="occupation" data-cy="input-occupation"/>
              </div>

            </div>
          </p-card>

          <p-card *ngIf="form.controls['donorTypeId']?.value">
            <div class="formgrid grid">

              <div class="field  col-12 sm:col-6 md:col-4 xl:col-3" *ngIf="form.controls['donorTypeId'].value !== '7' ">
                <label for="organization" [class]="labelClassNR">Organization</label>
                <input id="organization" type="text" pInputText formControlName="organization" data-cy="input-organization"/>
                <div *ngIf="form.controls['organization'].invalid && form.controls['organization'].touched"
                class="block p-error">
                  <small class="error" *ngIf="form.controls['organization'].errors?.['required']">
                    Please provide the donor organization name.
                  </small>
                </div>
              </div>

              <div class="field col-12 sm:col-6 md:col-4 xl:col-3">
                <label for="donorId" class="field-label">Donor ID</label>
                <input id="donorId" type="text" pInputText formControlName="donorId" [readonly]="true" [disabled]="true" data-cy="input-donor-id"/>
              </div>

              <div class="field  col-12 sm:col-6 md:col-4 xl:col-3">
                <label for="legacyId" class="field-label">Legacy ID</label>
                <input inputId="legacyId" id="legacyId" type="text" pInputText formControlName="legacyId" (keypress)="allowOnlyNumbers($event)" data-cy="input-legacy-id"/>
              </div>

              <div class="field  col-12 sm:col-6 md:col-4 xl:col-3" *ngIf="form.controls['donorTypeId'].value !== '7' ">
                <label for="fECCommitteeID" class="field-label">FEC Committee ID</label>
                <input id="fECCommitteeID" type="text" pInputText formControlName="fECCommitteeID" data-cy="input-fec-id"/>
              </div>

              <div class="field  col-12 sm:col-6 md:col-4 xl:col-3" *ngIf="form.controls['donorTypeId'].value === '7' ">
                <label for="candidateId" class="field-label">Candidate Id</label>
                <input id="candidateId" type="text" pInputText formControlName="candidateId" data-cy="input-candidate-id"/>
              </div>

              <div class="field  col-12 sm:col-6 md:col-4 xl:col-3" *ngIf="form.controls['donorTypeId'].value === '7' ">
                <label for="dateOfBirth" class="field-label">Date of Birth</label>
                <p-calendar id="dateOfBirth" formControlName="dateOfBirth" [showIcon]="true" [iconDisplay]="'input'" placeholder="MM/DD/YYYY" data-cy="input-date-of-birth">
                </p-calendar>
              </div>

            </div>
          </p-card>
        </form>

        <p-card *ngIf="form.controls['donorTypeId']?.value">
          <div *ngIf="isGIhasErrors" class="block p-error mb-3">
            <small class="error">
              Please review and correct the errors in this section before proceeding.
            </small>
          </div>
          <rc-generic-button level="secondary" borderStyle="solid" label="Next" (click)="validateGIAndProceed(nextCallback)" data-cy="btn-next"/>
        </p-card>
        
      </ng-template>
    </p-stepperPanel>

    <p-stepperPanel header="Contact">
      <ng-template pTemplate="content" let-prevCallback="prevCallback" let-nextCallback="nextCallback" let-index="index">
        <form [formGroup]="form"  data-cy="donor-contact-form">
          <p-card>
            <div formGroupName="address">
              <div class="grid gap-5" data-cy="add-address-form">
                <div class="col">
                  <div class="formgrid grid">

                    <div class="field col-12 sm:col-6 md:col-4 lg:col-3 xl:col-4 xxl:col-3">
                      <label for="addressTypeId" class="field-label">Address Type</label>
                      <p-dropdown id="addressTypeId" formControlName="addressTypeId" [options]="filteredAddressTypes"
                        optionLabel="value" placeholder="Please Select" optionValue="key" data-cy="dropdown-address-type"/>
                    </div>

                    <div class="field col-12 sm:col-6 md:col-8 lg:col-9 xl:col-8 xxl:col-9">
                      <label class="field-label">Primary Address</label>
                      <p-toggleButton name="isPrimary" onLabel="Yes" offLabel="No" onIcon="pi pi-check-circle"
                                      offIcon="pi pi-ban" formControlName="isPrimary" />
                    </div>

                    <div class="field col-12 sm:col-6 md:col-4 lg:col-3 xl:col-4 xxl:col-3">
                      <label for="addressLine1" class="field-label">Address 1</label>
                      <input id="addressLine1" type="text" pInputText formControlName="addressLine1" data-cy="input-address-one"/>
                      <div *ngIf="isAddressFieldsMandate" class="block p-error">
                        <small class="error">
                          Please enter at least one address field.
                        </small>
                      </div>
                    </div>

                    <div class="field col-12 sm:col-6 md:col-4 lg:col-3 xl:col-4 xxl:col-3">
                      <label for="addressLine2" class="field-label">Address 2</label>
                      <input id="addressLine2" type="text" pInputText formControlName="addressLine2" data-cy="input-address-two"/>
                    </div>

                    <div class="field col-12 sm:col-6 md:col-4 lg:col-3 xl:col-4 xxl:col-3">
                      <label for="city" class="field-label">City</label>
                      <input id="city" type="text" pInputText formControlName="city" data-cy="input-city"/>
                    </div>

                    <div class="field col-12 sm:col-6 md:col-4 lg:col-3 xl:col-4 xxl:col-3">
                      <label for="stateId" class="field-label">State</label>
                      <p-dropdown id="stateId" formControlName="stateId" [options]="states" optionLabel="value"
                                  placeholder="Please Select" optionValue="key" data-cy="dropdown-state"/>
                    </div>

                    <div class="field col-12 sm:col-6 md:col-4 lg:col-3 xl:col-4 xxl:col-3">
                      <label for="zipcode" class="field-label">Zip Code</label>
                      <input id="zipcode" type="text" pInputText formControlName="zipcode" data-cy="input-zip-code"/>
                    </div>

                    <div class="field col-12 sm:col-6 md:col-4 lg:col-3 xl:col-4 xxl:col-3">
                      <label for="county" class="field-label">County</label>
                      <input id="county" type="text" pInputText formControlName="county" data-cy="input-county"/>
                    </div>

                  </div>

                  <div class="flex justify-content-end align-items-center mt-2">
                    <rc-generic-button label="Clear Fields" (click)="clearAddress()" iconImg="xmark"
                                       borderStyle="text-only" level="secondary" size="small" [classes]="['mr-1']" data-cy="btn-clear"/>
                    <rc-generic-button label="Save Address" (click)="addAddress()" 
                    level="secondary" borderStyle="outline" data-cy="btn-save"/>
                  </div>

                </div>

                <div class="col-12 xl:col-5 xxl:col-4 section-divider" *ngIf="savedAddresses.length>0">

                  <p-table [value]="savedAddresses" styleClass="datatable-sm add-donor-datatable">
                    <ng-template pTemplate="header">
                      <tr>
                        <th>Addresses</th>
                        <th></th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-address>
                      <tr id="address-row">
                        <td>
                          <span [innerHTML]="getFormattedAddress(address)"></span>
                        </td>
                        <td>
                          <rc-generic-button label="Edit" iconImg="cog" iconColor="teal-light" [isIconOnly]="true" [classes]="['table-action-btn']" (click)="editAddress(address)" data-cy="btn-edit" />
                          <rc-generic-button label="Delete" iconImg="trash" iconColor="red-light" [isIconOnly]="true" data-cy="btn-delete"
                            [classes]="['table-action-btn']" (click)="confirmDelete($event, address, savedAddresses, 'Are you sure you want to delete this address?', 'address')" />
                        </td>
                      <tr>
                    </ng-template>
                  </p-table>

                </div>
              </div>
            </div>
          </p-card>

          <p-card>
            <div formGroupName="phoneNumber">
              <div class="grid gap-5" data-cy="add-phone-form">
                <div class="col">
                  <div class="formgrid grid">

                    <div class="field col-12 sm:col-6 xl:col-5 xxl:col-4">
                      <label for="phoneType" class="field-label">Phone Type</label>
                      <p-dropdown id="phoneType" formControlName="phoneType" [options]="filteredPhoneTypes"
                        optionLabel="value" placeholder="Please Select" optionValue="key" data-cy="dropdown-phone-type"/>

                        <!-- <div *ngIf="form.controls['phoneType'].invalid && form.controls['phoneType'].touched"
                           class="block p-error">
                          <small id="phoneType-error" class="error">
                            Please select PhoneType.
                          </small>
                        </div> -->
                    </div>

                    <div class="field col-12 sm:col-6 xl:col-5 xxl:col-4">

                      <!-- <rc-input
                      label="Phone Number"
                      mask="999-999-9999"
                      placeholder="999-999-9999"
                      type="masked"
                      [control]="form.controls['phoneNumber']"
                      /> -->

                      <label for="phoneNumber" class="field-label">Phone Number</label>
                      <input id="phoneNumber" type="text" pInputText formControlName="phoneNumber" maxlength="14"
                             (input)="formatPhoneNumber($event,'phoneNumber')" (keypress)="allowOnlyNumbers($event)" data-cy="input-phone"/>
                      <div *ngIf="form.controls['phoneNumber'].invalid && form.controls['phoneNumber'].touched"
                           class="block p-error">
                        <small id="phoneNumber-error" class="error">
                          Please enter a valid phone number.
                        </small>
                      </div>

                    </div>
                  </div>

                  <div class="flex justify-content-end align-items-center mt-2">
                    <rc-generic-button label="Clear Fields" (click)="clearPhoneNumber()" iconImg="xmark"
                                       borderStyle="text-only" level="secondary" size="small" data-cy="btn-clear"/>
                    <rc-generic-button level="secondary" label="Save Phone" borderStyle="outline"
                    (click)="addPhoneNumber()" data-cy="btn-save"/>
                  </div>
                </div>

                <div class="col-12 xl:col-5 xxl:col-4 section-divider" *ngIf="savedPhoneNumbers.length>0">

                  <p-table [value]="savedPhoneNumbers" styleClass="datatable-sm add-donor-datatable">
                    <ng-template pTemplate="header">
                      <tr>
                        <th>Phone Numbers</th>
                        <th></th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-phoneNumber>
                      <tr id="phone-row">
                        <td>
                          <span [innerHTML]="getFormattedPhoneNumber(phoneNumber)"></span>
                        </td>
                        <td>
                          <rc-generic-button label="Edit" iconImg="cog" iconColor="teal-light" [isIconOnly]="true" [classes]="['table-action-btn']" (click)="editPhoneNumber(phoneNumber)" data-cy="btn-edit"/>
                          <rc-generic-button label="Delete" iconImg="trash" iconColor="red-light" [isIconOnly]="true" data-cy="btn-delete"
                            [classes]="['table-action-btn']" (click)="confirmDelete($event, phoneNumber, savedPhoneNumbers, 'Are you sure you want to delete this phone?','phone')" />
                        </td>
                      <tr>
                    </ng-template>
                  </p-table>

                </div>
              </div>
            </div>
          </p-card>

          <p-card>
            <div formGroupName="email">
              <div class="grid gap-5" data-cy="add-email-form">
                <div class="col">
                  <div class="formgrid grid">
                    <div class="field col-12 sm:col-6 xl:col-5 xxl:col-4">
                      <label for="type" class="field-label">Email Type</label>
                      <p-dropdown id="type" formControlName="type" [options]="filteredEmailTypes"
                        optionLabel="value" placeholder="Please Select" optionValue="key" data-cy="dropdown-email-type"/>
                    </div>
                    <div class="field col-12 sm:col-6 xl:col-5 xxl:col-4">
                      <label for="email" class="field-label">Email</label>
                      <input id="email" type="email" pInputText formControlName="email" placeholder="" data-cy="input-email"/>
                      <div *ngIf="form.controls['email'].invalid && form.controls['email'].touched" class="block p-error">
                        <small id="email-error" class="error">Please enter a valid email address.</small>
                      </div>
                    </div>
                  </div>

                  <div class="flex justify-content-end align-items-center mt-2">
                    <rc-generic-button label="Clear Fields" (click)="clearEmail()" iconImg="xmark"
                                       borderStyle="text-only" level="secondary" size="small" [classes]="['mr-1']" data-cy="btn-clear"/>
                    <rc-generic-button level="secondary" label="Save Email" borderStyle="outline" (click)="addEmail()" data-cy="btn-save"/>
                  </div>

                </div>

                <div class="col-12 xl:col-5 xxl:col-4 section-divider" *ngIf="savedEmails.length>0">

                  <p-table [value]="savedEmails" styleClass="datatable-sm add-donor-datatable">
                    <ng-template pTemplate="header">
                      <tr>
                        <th>Emails</th>
                        <th></th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-email>
                      <tr id="email-row">
                        <td>
                          <span [innerHTML]="getFormattedEmail(email)"></span>
                        </td>
                        <td>
                          <rc-generic-button label="Edit" iconImg="cog" iconColor="teal-light" [isIconOnly]="true" [classes]="['table-action-btn']" (click)="editEmail(email)" />
                          <rc-generic-button label="Delete" iconImg="trash" iconColor="red-light" [isIconOnly]="true" data-cy="btn-Delete"
                            [classes]="['table-action-btn']" (click)="confirmDelete($event, email, savedEmails, 'Are you sure you want to delete this email?','email')" />
                        </td>
                      <tr>
                    </ng-template>
                  </p-table>

                </div>
              </div>
            </div>
          </p-card>

          <p-card>
            <div *ngIf="isContactshasErrors" class="block p-error mb-3">
              <small class="error"> You haven't saved your changes yet. Please save them before proceeding. </small>
            </div>
            <rc-generic-button level="secondary" borderStyle="outline" label="Previous" (click)="prevCallback.emit()" data-cy="btn-previous"/>
            <rc-generic-button level="secondary" borderStyle="solid" label="Next" (click)="validateContactsAndProceed(nextCallback)" data-cy="btn-next"/>
          </p-card>

        </form>
      </ng-template>

    </p-stepperPanel>

    <p-stepperPanel header="Relationships">
      <ng-template pTemplate="content" let-prevCallback="prevCallback" let-nextCallback="nextCallback" let-index="index">
        <form [formGroup]="form" data-cy="donor-relationship-form">

          <p-card>
            <div formGroupName="relationshipTypes">
              <div class="grid gap-5">

                <div class="col">
                  <div class="formgrid grid">
                    <div class="field col-12 sm:col-6 xl:col-5 xxl:col-4">
                      <label for="firstName" class="field-label">First Name</label>
                      <p-autoComplete id="firstName" formControlName="firstName" [suggestions]="filteredFirstNames"
                                      [field]="'text'" placeholder="Type to search"
                                      minLength="3" delay="300"
                                      (completeMethod)="filterByFirstname($event)"
                                      (onSelect)="onRelationshipSelect($event)" 
                                      [emptyMessage]="'No donors found'"
                                      data-cy="auto-first-name">
                        <ng-template let-suggestion pTemplate="empty">
                          <div class="no-result">
                            <span>No donors found</span>
                          </div>
                          <div>&nbsp;</div>
                          <div class="add-donor">
                            <rc-generic-button label="Add New Donor" iconImg="plus" borderStyle="text-only" level="secondary" size="small" [classes]="['mx-1']" (click)="showAddNewDonorDialog = true" data-cy="btn-add-donor"/>
                          </div>
                        </ng-template>
                      </p-autoComplete>
                        <div *ngIf=" form.get('relationshipTypes.firstName')?.invalid && form.get('relationshipTypes.firstName')?.touched" class="block p-error">
                          <small class="error"> Please select first name. </small>
                        </div>
                        <div *ngIf="inValidFirstName">
                          <small id="relationshipType-error" class="error">Please select a valid first name.</small>
                        </div>
                    </div>

                    <div class="field col-12 sm:col-6 xl:col-5 xxl:col-4">
                      <label for="lastName" class="field-label">Last Name</label>
                      <p-autoComplete id="lastName" formControlName="lastName" [suggestions]="filteredLastNames"
                                      [field]="'text'" placeholder="Type to search"
                                      minLength="3" delay="300"
                                      (completeMethod)="filterByLastname($event)"
                                      (onSelect)="onRelationshipSelect($event)"
                                      [emptyMessage]="'No donors found'"
                                      data-cy="auto-last-name">
                        <ng-template let-suggestion pTemplate="empty">
                          <div class="no-result">
                            <rc-generic-button label="Add New Donor" iconImg="plus" borderStyle="text-only" level="secondary" size="small" [classes]="['mx-1']" (click)="showAddNewDonorDialog = true" data-cy="btn-add-donor"/>
                          </div>
                        </ng-template>
                      </p-autoComplete>
                      <div *ngIf=" form.get('relationshipTypes.lastName')?.invalid && form.get('relationshipTypes.lastName')?.touched" class="block p-error">
                        <small class="error"> Please select last name. </small>
                      </div>
                      <div *ngIf="inValidLastName">
                        <small id="relationshipType-error" class="error">
                          Please select a valid last name.
                        </small>
                      </div>
                    </div>

                    <div class="field col-12 sm:col-6 xl:col-5 xxl:col-4">
                      <label for="relationshipTypeId" class="field-label">Relationship Type</label>
                      <p-dropdown id="relationshipTypeId" formControlName="relationshipTypeId"
                        [options]="filteredRelationshipTypeOptions" optionLabel="text" placeholder="Please Select"
                        optionValue="value" data-cy="dropdown-relationship-type"/>
                        <div *ngIf=" form.get('relationshipTypes.relationshipTypeId')?.invalid && form.get('relationshipTypes.relationshipTypeId')?.touched" class="block p-error">
                          <small class="error"> Please select relationship type. </small>
                        </div>

                      <rc-generic-button label="Add New Type" iconImg="plus" borderStyle="text-only" level="secondary" size="small" [classes]="['mt-2']" (click)="showDialog = true" data-cy="btn-add-type"/>
                    </div>

                    <div class="field col-12 sm:col-6 xl:col-5 xxl:col-4">
                      <label for=" " class="field-label">Same Household</label>
                      <p-toggleButton name="isHousehold" onLabel="Yes" offLabel="No" onIcon="pi pi-check-circle"
                                      offIcon="pi pi-ban" formControlName="isHousehold" />
                    </div>
                  </div>

                  <div class="flex justify-content-end align-items-center mt-2">
                    <rc-generic-button label="Clear Fields" (click)="clearRelationship()" iconImg="xmark" borderStyle="text-only" level="secondary" size="small" [classes]="['mr-1']" data-cy="btn-clear"/>
                    <rc-generic-button level="secondary" label="Save Relationship" borderStyle="outline" (click)="addRelationship()" data-cy="btn-save-relationship"/>
                  </div>

                </div>

                <div class="col-12 xl:col-5 xxl:col-4 section-divider" *ngIf="savedRelationships.length>0">

                  <p-table [value]="savedRelationships" styleClass="datatable-sm add-donor-datatable">
                    <ng-template pTemplate="header">
                      <tr>
                        <th>Relationships</th>
                        <th></th>
                        <th></th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rs data-cy="added-relationship">
                      <tr>
                        <td>
                          <span [innerHTML]="getFormattedRT(rs)"></span>
                        </td>
                        <td>
                          <span [hidden]="!rs.isHousehold">
                            <i class="fa-sharp fa-regular fa-house-circle-check same-household-yes" title="Same Household"></i>
                          </span>
                          <span [hidden]="rs.isHousehold">
                            <i class="fa-sharp fa-light fa-house same-household-no" title="Not Same Household"></i>
                          </span>
                        </td>
                        <td>
                          <!-- <rc-generic-button label="Edit" iconImg="cog" iconColor="teal-light" [isIconOnly]="true"
                            [classes]="['table-action-btn']" (click)="editRT(rs)" /> -->
                          <rc-generic-button label="Delete" iconImg="trash" iconColor="red-light" [isIconOnly]="true" data-cy="btn-Delete"
                            [classes]="['table-action-btn']" (click)="confirmDelete($event, rs, savedRelationships, 'Are you sure you want to delete this relationship?','relationship')" />
                        </td>
                      <tr>
                    </ng-template>
                  </p-table>

                </div>
              </div>
            </div>
          </p-card>

          <p-card>
            <div *ngIf="isRelationshipHasErrors" class="block p-error mb-3">
              <small class="error">
                Please review and correct the errors in this section before proceeding.
              </small>
            </div>
            <rc-generic-button level="secondary" borderStyle="outline" label="Previous" (click)="prevCallback.emit()" data-cy="btn-previous"/>
            <rc-generic-button level="secondary" borderStyle="solid" label="Next" (click)="validateRelationshipAndProceed(nextCallback)" data-cy="btn-next"/>
            
          </p-card>

        </form>
      </ng-template>
    </p-stepperPanel>

    <p-stepperPanel header="Additional Data">
      <ng-template pTemplate="content"  let-prevCallback="prevCallback" let-nextCallback="nextCallback" let-index="index">
        <form [formGroup]="form">

          <p-card>
            <div class="grid gap-5" data-cy="additional-data-form">
              <div class="col">
                <div class="formgrid grid">
                  <div class="field col-12 sm:col-6 xl:col-5 xxl:col-4">
                    <label for="donorFlagType" class="field-label">Donor Flag</label>
                    <p-autoComplete id="donorFlagType" formControlName="donorFlagType"
                                    [suggestions]="filteredDonorFlags" (completeMethod)="filterDonorFlags($event)" field="value"
                                    placeholder="Type to search" (onSelect)="addDonorFlag()" data-cy="auto-flag-type"/>

                    <rc-generic-button label="Add New Type" iconImg="plus" borderStyle="text-only" level="secondary" size="small" [classes]="['mt-2']" (click)="showDialog = true" data-cy="btn-add-type"/>

                  </div>
                </div>
              </div>

              <div class="col-12 xl:col-5 xxl:col-4 section-divider" *ngIf="savedDonorFlags.length>0">

                <p-table [value]="savedDonorFlags" styleClass="datatable-sm add-donor-datatable">
                  <ng-template pTemplate="header">
                    <tr>
                      <th>Donor Flags</th>
                      <th></th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-donorFlag>
                    <tr>
                      <td>
                        <span>{{donorFlag.value}}</span>
                      </td>
                      <td>
                        <rc-generic-button label="Delete" iconImg="trash" iconColor="red-light" [isIconOnly]="true" data-cy="btn-Delete"
                          [classes]="['table-action-btn']" (click)="confirmDelete($event, donorFlag, savedDonorFlags, 'Are you sure you want to delete this donor flag?','donorFlag')" />
                      </td>
                    </tr>
                  </ng-template>
                </p-table>

              </div>
            </div>
          </p-card>

          <p-card>
            <div class="formgrid grid">

              <div class="field  col-12 sm:col-6 md:col-4 xl:col-3 xxl:col-3">
                <label for="informalName" class="field-label">Informal Name</label>
                <input id="informalName" type="text" pInputText formControlName="informalName" data-cy="input-informal-name"/>
              </div>

              <div class="field  col-12 sm:col-6 md:col-4 xl:col-3 xxl:col-3">
                <label for="formalSalutation" class="field-label">Formal Salutation</label>
                <input id="formalSalutation" type="text" pInputText formControlName="formalSalutation" data-cy="input-formal-name"/>
              </div>

              <div class="field col-12 sm:col-6 md:col-4 xl:col-3 xxl:col-3">
                <label for="mailSalutation" class="field-label">Mail Salutation</label>
                <input id="mailSalutation" type="text" pInputText formControlName="mailSalutation" data-cy="input-mail-name"/>
              </div>

            </div>
          </p-card>

          <p-card>
            <div class="formgrid grid">

              <div class="field col white-space-nowrap">
                <p-checkbox [binary]="true" label="Do Not Solicit" formControlName="doNotSolicit" name="doNotSolicit" data-cy="checkbox-doNotSolicit"/>
              </div>

              <div class="field col white-space-nowrap">
                <p-checkbox [binary]="true" label="Do Not Mail" formControlName="doNotMail" name="doNotMail" data-cy="checkbox-doNotMail"/>
              </div>

              <div class="field col white-space-nowrap">
                <p-checkbox [binary]="true" label="Do Not Email" formControlName="doNotEmail" name="doNotEmail" data-cy="checkbox-doNotEmail"/>
              </div>

              <div class="field col white-space-nowrap">
                <p-checkbox [binary]="true" label="Do Not Call" formControlName="doNotCall" name="doNotCall" data-cy="checkbox-doNotCall"/>
              </div>

              <div class="field col white-space-nowrap">
                <p-checkbox [binary]="true" label="Is Deceased" name="isDeceased" formControlName="isDeceased" data-cy="checkbox-isDeceased"/>
              </div>
            </div>
          </p-card>
          <p-card>
            <rc-generic-button level="secondary" borderStyle="outline" label="Previous" (click)="prevCallback.emit()" data-cy="btn-previous"/>
          </p-card> 
        </form>
      </ng-template>
    </p-stepperPanel>
  </p-stepper>
   
  <p-card styleClass="page-footer">
    <rc-generic-button label="Cancel" borderStyle="text-only" (click)="cancelDialog()" data-cy="btn-cancel"/>
    <rc-generic-button label="Save" (click)="save($event)" data-cy="btn-save"/>
  </p-card>
</div>

<!-- =========== MODALS ============= -->
<!-- EDIT contact info MODAL -->
<p-dialog [(visible)]="editItemDialog" 
  [modal]="true" 
  styleClass="p-dialog-static p-dialog-sm fadeinright animation-duration-300">

  <ng-template pTemplate="header">
    <span class="h3 mb-0 white-space-nowrap">Edit {{ getDialogTitle(dialogType) }}</span>
  </ng-template>

  <ng-container *ngIf="dialogType ==='address'">
    <ng-template #dialogHeader>
      <span class="h3 mb-0 white-space-nowrap">Edit Address</span>
    </ng-template>
    <form [formGroup]="editAddressForm">
      <div class="formgrid grid" data-cy="edit-address-form">

        <div class="field col-12">
          <label for="addressTypeId" class="field-label">Address Type</label>
          <p-dropdown id="addressTypeId" formControlName="addressTypeId" [options]="editFilteredAddressTypes" optionLabel="value"
            placeholder="Please Select" optionValue="key" data-cy="dropdown-address-type"/>
        </div>

        <div class="field col-12 sm:col-6 md:col-8 lg:col-9 xl:col-8 xxl:col-9">
          <label class="field-label">Primary Address</label>
          <p-toggleButton name="isPrimary" onLabel="Yes" offLabel="No" onIcon="pi pi-check-circle" offIcon="pi pi-ban"
                          formControlName="isPrimary" data-cy="toggle-primary-address"/>
        </div>

        <div class="field col-12">
          <label for="address1" class="field-label">Address 1</label>
          <input id="address1" type="text" pInputText formControlName="addressLine1" data-cy="input-address-one"/>
          <div *ngIf="isEditAddressFieldsMandate" class="block p-error">
            <small class="error">
              Please enter at least one address field.
            </small>
          </div>
        </div>

        <div class="field col-12">
          <label for="addressLine2" class="field-label">Address 2</label>
          <input id="addressLine2" type="text" pInputText formControlName="addressLine2" data-cy="input-address2"/>
        </div>

        <div class="field col-12">
          <label for="city" class="field-label">City</label>
          <input id="city" type="text" pInputText formControlName="city" data-cy="input-city"/>
        </div>

        <div class="field col-12">
          <label for="stateId" class="field-label">State</label>
          <p-dropdown id="stateId" formControlName="stateId" [options]="states" optionLabel="value"
                      placeholder="Please Select" optionValue="key" data-cy="dropdown-state"/>
        </div>

        <div class="field col-12">
          <label for="zipcode" class="field-label">Zip Code</label>
          <input id="zipcode" type="text" pInputText formControlName="zipcode" data-cy="input-zip-code"/>
        </div>

        <div class="field col-12">
          <label for="county" class="field-label">County</label>
          <input id="county" type="text" pInputText formControlName="county" data-cy="input-county"/>
        </div>

      </div>
    </form>
  </ng-container>

  <ng-container *ngIf="dialogType ==='phoneNumber'">

    <form [formGroup]="editPhoneNumberForm">

      <div class="formgrid grid" data-cy="edit-phone-form">
        <div class="field col-12">
          <label for="phoneType" class="field-label">Phone Type</label>
          <p-dropdown id="phoneType" formControlName="phoneType" [options]="editFilteredPhoneTypes" optionLabel="value"
            placeholder="Please Select" optionValue="key" data-cy="dropdown-phone-type"/>
        </div>
        <div class="field col-12">
          <label for="phoneNumber" class="field-label">PhoneNumber</label>
          <input id="phoneNumber" type="text" pInputText formControlName="phoneNumber" maxlength="14"
            (input)="formatPhoneNumber($event,'editPhoneNumber')" (keypress)="allowOnlyNumbers($event)" data-cy="input-phone"/>
          <div *ngIf="editPhoneNumberForm.get('phoneNumber')?.invalid && editPhoneNumberForm?.get('phoneNumber')?.touched" class="block p-error">
            <small id="phoneNumber-error" class="error">
              Please enter a valid phone number.
            </small>
          </div>
        </div>
      </div>
    </form>

  </ng-container>

  <ng-container *ngIf="dialogType ==='email'">

    <form [formGroup]="editEmailForm">
      <div class="formgrid grid" data-cy="edit-email-form">
        <div class="field col-12">
          <label for="type" class="field-label">Email Type</label>
          <p-dropdown id="type" formControlName="type" [options]="editFilteredEmailTypes" optionLabel="value"
            placeholder="Please Select" optionValue="key" data-cy="dropdown-email-type"/>

          <div *ngIf="editEmailForm.get('type')?.invalid && editEmailForm.get('type')?.touched" class="block p-error">
            <small id="type-error" class="error">
              Please select an email type to proceed.
            </small>
          </div>
        </div>
        <div class="field col-12">
          <label for="email" class="field-label">Email</label>
          <input id="email" type="email" pInputText formControlName="email" placeholder="" data-cy="input-email"/>
          <div *ngIf="editEmailForm.get('email')?.invalid && editEmailForm.get('email')?.touched"
               class="block p-error">
            <small id="email-error" class="error">Please enter a valid email address.</small>
          </div>
        </div>
      </div>
    </form>

  </ng-container>

  <div>&nbsp;</div>

  <ng-template pTemplate="footer">
    <rc-generic-button label="Cancel" borderStyle="text-only" (click)="closeEditItemDialog()" data-cy="btn-cancel"/>
    <rc-generic-button   label="Save" (click)="saveEditItem()" data-cy="btn-save"/>
  </ng-template>

</p-dialog>

<!-- Add New Relationship Type MODAL -->
<p-dialog [(visible)]="showDialog" 
  [modal]="true"
  header="Add New Relationship Type"
  (onHide)="clearSaveRelationshipType()"
  styleClass="p-dialog-static p-dialog-sm fadeinright animation-duration-300">

  <form [formGroup]="editSaveRelationshipType">

    <div class="formgrid grid" data-cy="edit-relationship-form">
      <div class="field col-12">
        <label for="relationshipType" class="field-label">Relationship Type</label>
        <input id="relationshipType" type="text" pInputText formControlName="relationshipType" (input)="duplicateRelationshipType = false" data-cy="input-relationship-type"/>
        <div *ngIf="editSaveRelationshipType.get('relationshipType')?.invalid && editSaveRelationshipType.get('relationshipType')?.touched"
          class="block p-error">
          <small id="relationshipType-error" class="error">
            Please enter a valid relationship type.
          </small>
        </div>

        <div *ngIf="duplicateRelationshipType" class="block p-error">
          <small id="relationshipType-error" class="error">
            This relationship type already exists. Please choose a different one.
          </small>
        </div>

      </div>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <rc-generic-button label="Cancel" borderStyle="text-only" (click)="clearSaveRelationshipType()" data-cy="btn-cancel"/>
    <rc-generic-button label="Save" (click)="saveNewRelationship()" data-cy="btn-save"/>
  </ng-template>
</p-dialog>

<!-- Add New Donor MODAL -->
<p-dialog [(visible)]="showAddNewDonorDialog" 
  [modal]="true" 
  header=" Add New Donor"
  styleClass="p-dialog-static p-dialog-sm fadeinright animation-duration-300"
  (onHide)="clearAddNewDonorDialog()">

  <form [formGroup]="addNewDonorFromRelationship">
    <div class="formgrid grid" data-cy="add-donor-form">
      <div class="field col-12">
        <label for="firstName" [class]="labelClassR">First Name</label>
        <input id="firstName" type="text" pInputText formControlName="firstName" data-cy="input-first-name"/>
        <div *ngIf="addNewDonorFromRelationship.controls['firstName'].errors && addNewDonorFromRelationship.controls['firstName'].touched" class="block p-error">
          <small class="error" *ngIf="addNewDonorFromRelationship.controls['firstName'].errors?.['required']">
            Please provide a first name.
          </small>
          <small class="error" *ngIf="addNewDonorFromRelationship.controls['firstName'].errors?.['invalidName']">
            Please enter a valid first name.
          </small>
          <small class="error" *ngIf="addNewDonorFromRelationship.controls['firstName'].errors?.['noNumbers']">
            Numbers are not allowed.
          </small>
        </div>
      </div>

      <div class="field col-12">
        <label for="lastName" [class]="labelClassR">Last Name</label>
        <input id="lastName" type="text" pInputText formControlName="lastName" data-cy="input-last-name"/>
        <div *ngIf="addNewDonorFromRelationship.controls['lastName'].invalid && addNewDonorFromRelationship.controls['lastName'].touched" class="block p-error">
          <small class="error" *ngIf="addNewDonorFromRelationship.controls['lastName'].errors?.['required']">
            Please provide a last name.
          </small>
          <small class="error" *ngIf="addNewDonorFromRelationship.controls['lastName'].errors?.['invalidName']">
            Please enter a valid last name.
          </small>
          <small class="error" *ngIf="addNewDonorFromRelationship.controls['lastName'].errors?.['noNumbers']">
            Numbers are not allowed.
          </small>
        </div>
      </div>

      <div class="field col-12">
        <label class="field-label">Add addresses from the original donor</label>
        <p-toggleButton name="isSaveAddressSelected" onLabel="Yes" offLabel="No" onIcon="pi pi-check-circle" offIcon="pi pi-ban" formControlName="isSaveAddressSelected" />
      </div>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <rc-generic-button label="Cancel" borderStyle="text-only" (click)="clearAddNewDonorDialog()" data-cy="btn-cancel"/>
    <rc-generic-button label="Save" (click)="saveNewDonor($event)" data-cy="btn-save"/>
  </ng-template>
</p-dialog>

<!-- Add New Donor Flag Type MODAL -->
<p-dialog [(visible)]="showDialog" 
  [modal]="true" 
  header="Add New Donor Flag Type"
  styleClass="p-dialog-static p-dialog-sm fadeinright animation-duration-300" 
  (onHide)="clearNewDonorFlagType()">

  <form [formGroup]="editSaveDonorFlag">
    <div class="formgrid grid" data-cy="edit-flag-form">
      <div class="field col-12">
        <label for="title" class="field-label">Donor Flag Name</label>
        <input id="title" type="text" pInputText formControlName="title" data-cy="input-flag-title"/>
        <div *ngIf="editSaveDonorFlag.get('title')?.invalid && editSaveDonorFlag.get('title')?.touched" class="block p-error">
          <small id="title-error" class="error">
            Title is required to proceed.
          </small>
        </div>
      </div>

      <div class="field col-12">
        <label for="year" class="field-label">Cycle Year</label>
        <input id="year" type="text" pInputText placeholder="YYYY" formControlName="year" [maxlength]="4" data-cy="input-flag-year"/>

        <div *ngIf="editSaveDonorFlag.get('year')?.invalid && editSaveDonorFlag.get('year')?.touched">
          <small id="cycleYear-error" class="error">
            Year is required to proceed.
          </small>
        </div>
      </div>

      <div class="field col-12">
        <label for="description" class="field-label">Flag Description</label>
        <textarea rows="5" class="w-full p-inputtextarea p-inputtext p-component p-element" pInputTextarea
                  formControlName="description"></textarea>
        <div *ngIf="editSaveDonorFlag.get('description')?.invalid && editSaveDonorFlag?.get('description')?.touched" class="block p-error">
          <small id="description-error" class="error">
            Please enter a description.
          </small>
        </div>

      </div>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <rc-generic-button label="Cancel" borderStyle="text-only" (click)="clearNewDonorFlagType()" data-cy="btn-cancel"/>
    <rc-generic-button label="Save" (click)="saveNewDonorFlagType()" data-cy="btn-save"/>
  </ng-template>

</p-dialog>
